import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
    SHIPMENTADDRESSES_FEATURE_KEY,
    State,
    ShipmentAddressesPartialState,
    shipmentAddressesAdapter,
} from './shipment-addresses.reducer';

// Lookup the 'ShipmentAddresses' feature state managed by NgRx
export const getShipmentAddressesState = createFeatureSelector<
    ShipmentAddressesPartialState,
    State
>(SHIPMENTADDRESSES_FEATURE_KEY);

const { selectAll, selectEntities } = shipmentAddressesAdapter.getSelectors();

export const getShipmentAddressesLoading = createSelector(
    getShipmentAddressesState,
    (state: State) => state.loading
);

export const getShipmentAddressesError = createSelector(
    getShipmentAddressesState,
    (state: State) => state.error
);

export const getAllShipmentAddresses = createSelector(
    getShipmentAddressesState,
    (state: State) => selectAll(state)
);

export const getShipmentAddressesEntities = createSelector(
    getShipmentAddressesState,
    (state: State) => selectEntities(state)
);

export const getSelectedId = createSelector(
    getShipmentAddressesState,
    (state: State) => state.selectedId
);

export const getSelected = createSelector(
    getShipmentAddressesEntities,
    getSelectedId,
    (entities, selectedId) => selectedId && entities[selectedId]
);
